import script from "./commission-wallet.vue?vue&type=script&setup=true&lang=js"
export * from "./commission-wallet.vue?vue&type=script&setup=true&lang=js"

import "./commission-wallet.vue?vue&type=style&index=0&id=79d5d018&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79d5d018"]])

export default __exports__